import { atom } from 'recoil'

export const cancelSpecial = atom({
  key: 'cancelSpecial',
  default: false,
})
